// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tax-optimisation_content__rEKve {
    display: flex;
    grid-gap: 40px;
    /*width: calc(100vw - 200px);*/
    max-width: 100%;
    width: var(--container-width);
    padding: 28px var(--container-padding);
    margin: auto;
    height: calc(100vh - var(--header-height));

    --group-width: 270px;
}

.tax-optimisation_groupsContainer__WoOdP {
    flex: 1 1;
    display: flex;
    flex-direction: column;

    /*flex-direction: row;*/
    /*position: relative;*/
    /*align-items: center;*/
    grid-gap: 32px;
}

.tax-optimisation_groupsContainer__WoOdP > div:not(.tax-optimisation_actions__Naaln) {
    flex: 1 1;
}

.tax-optimisation_groups__k6Aml {
    justify-content: flex-start;
    flex-wrap: wrap;
    column-gap: 69px;
    row-gap: 2px;
    margin: 0 auto;
    /*min-width: 1086px;*/
}

.tax-optimisation_groups__k6Aml:not(.tax-optimisation_open__5YNxA) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(var(--group-width), var(--group-width)));
}

.tax-optimisation_group__4iltN {
    position: relative;
    width: var(--group-width);
    /*transition: 0.1s;*/
    /*display: flex;*/
    /*flex-direction: column;*/

    /*display: grid;*/
    /*grid-row: span 6;*/
    /*grid-template-rows: subgrid;*/
}

.tax-optimisation_groupTitle__CjnSI {
    margin: 0 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tax-optimisation_groupTitle__CjnSI button.tax-optimisation_hidden__BFdT- {
    display: none;
}

.tax-optimisation_groupTitle__CjnSI h5 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: var(--group-width);
    margin: auto 0;
}

.tax-optimisation_group__4iltN.tax-optimisation_closed__iht76 .tax-optimisation_groupTitleNumber__W1uYT {
    display: none;
}

.tax-optimisation_groupTitleNumber__W1uYT {
    color: var(--secondary-color);
    font-weight: 400;
    padding-right: 10px;
}

.tax-optimisation_groupItems__QjZRY {
    flex: 1 1;
    --total: 0;
    display: flex;
    flex-wrap: wrap;
    transition: padding 0.1s;
    padding-left: calc(var(--total, 0) * 8px);
}

.tax-optimisation_groupItems__QjZRY a > div:last-child {
    margin-left: calc(var(--total, 0) * 8px * -1);
}

.tax-optimisation_groupItems__QjZRY.tax-optimisation_closed__iht76:has(a:nth-child(2):last-child) {
    padding-top: 8px;
    /*padding-left: 8px;*/
    margin-top: -8px;
}

.tax-optimisation_groupItems__QjZRY.tax-optimisation_closed__iht76:has(a:nth-child(3):last-child) {
    padding-top: 16px;
    /*padding-left: 16px;*/
    margin-top: -16px;
}

.tax-optimisation_groupItems__QjZRY.tax-optimisation_closed__iht76:has(a:nth-child(4)) {
    padding-top: 24px;
    /*padding-left: 24px;*/
    margin-top: -24px;
}

.tax-optimisation_groupItems__QjZRY.tax-optimisation_closed__iht76 * {
    pointer-events: none;
}

.tax-optimisation_groupItems__QjZRY.tax-optimisation_open__5YNxA {
    row-gap: 32px;
    grid-template-columns: repeat(auto-fit, minmax(226px, 226px));
    display: grid;
    grid-gap: 60px;
    /*justify-content: center;*/
}

.tax-optimisation_group__4iltN.tax-optimisation_open__5YNxA {
    width: 100%;
}

.tax-optimisation_group__4iltN.tax-optimisation_hidden__BFdT- {
    display: none;
}

.tax-optimisation_actions__Naaln {
    text-align: center;
    margin: 0 0 60px auto;
    /*padding-top: 32px;*/
    width: 200px;
    min-width: 200px;
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
}

.tax-optimisation_imgWrapper__ccQgE {
    border: 1px solid #7b848e;
    margin-bottom: 12px;
    text-align: center;
    display: flex;
    flex-direction: column;
    padding: 4px 24px;
    color: #1650b4;
    font-size: 16px;
    width: 179px;
    max-height: 156px;
}

.tax-optimisation_imgWrapper__ccQgE img {
    margin: 0 auto;
    max-width: 96%;
    height: auto;
}

.tax-optimisation_selection__xuzpm {
    width: 179px;
}

.tax-optimisation_selection__xuzpm img {
    width: 25px;
}

.tax-optimisation_selection__xuzpm h6,
.tax-optimisation_selection__xuzpm span {
    font-size: 13px;
}

.tax-optimisation_selection__xuzpm > div {
    margin-bottom: 4px;
    max-width: 100%;
}

.tax-optimisation_selection__xuzpm > div:not(:first-child) {
    padding-left: 32px;
}

.tax-optimisation_selection__xuzpm > div img {
    width: 20px;
}

.tax-optimisation_link__vXDAM.tax-optimisation_open__5YNxA {
    margin-right: 30px;
}

.tax-optimisation_buttons__CsTRb {
    display: flex;
    grid-gap: 16px;
}

.tax-optimisation_btnIcon__X0Ne8 {
    display: flex;
    align-items: center;
    grid-gap: 11px;
    padding-left: 13px;
    padding-right: 21px;
}

.tax-optimisation_tableContent__eU\\+EH .tax-optimisation_tableWrapper__SHidf {
    overflow: hidden;
    max-height: 0;
    border-bottom: 1px solid var(--light-grey);
}

.tax-optimisation_tableWrapper__SHidf td {
    text-align: center;
}

.tax-optimisation_tableContent__eU\\+EH h3 {
    padding: 15px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.tax-optimisation_tableContent__eU\\+EH h3 button {
    width: 25px;
    height: 25px;
    color: var(--dark-grey);
    transform: rotate(90deg);
    transition: transform 0.4s;
}

.tax-optimisation_tableContent__eU\\+EH.tax-optimisation_open__5YNxA .tax-optimisation_tableWrapper__SHidf {
    max-height: 100000px;
}

.tax-optimisation_tableContent__eU\\+EH.tax-optimisation_open__5YNxA h3 button {
    color: var(--primary-color-active);
    transform: rotate(180deg);
}

.tax-optimisation_tableContent__eU\\+EH table {
    width: 100%;
}

.tax-optimisation_tableContent__eU\\+EH th {
    position: relative;
    padding: 9px;
}
.tax-optimisation_tableContent__eU\\+EH th:not(:last-child):after {
    content: '';
    position: absolute;
    bottom: 0;
    display: block;
    width: 90%;
    left: 5%;
    border-bottom: 1px solid var(--dark-grey);
}

.tax-optimisation_tableContent__eU\\+EH th:first-child:after {
    width: 95%;
    left: 0;
}

.tax-optimisation_tableContent__eU\\+EH td {
    padding: 4px 11px;
}

.tax-optimisation_tableContent__eU\\+EH tr:not(:last-child) td:not(:last-child) {
    border-bottom: 1px solid var(--light-grey);
}

.tax-optimisation_selectedHeader__8Tm9S {
    margin-bottom: calc(var(--container-margin) - 10px);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .tax-optimisation_content__rEKve {
        width: 100%;
        --group-width: 240px;
    }

    .tax-optimisation_groupsContainer__WoOdP {
        /*flex-direction: column;*/
        transition: padging 0.4s;
    }

    .tax-optimisation_groups__k6Aml {
        column-gap: 35px;
    }

    /*.groupsContainer.collapsed {*/
    /*    padding-left: 300px;*/
    /*}*/

    .tax-optimisation_actions__Naaln {
        margin: auto auto 30px;
        padding: 30px 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TaxOptimisation/tax-optimisation.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,6BAA6B;IAC7B,sCAAsC;IACtC,YAAY;IACZ,0CAA0C;;IAE1C,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;;IAEtB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uFAAuF;AAC3F;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;;IAE1B,iBAAiB;IACjB,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,UAAU;IACV,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,6DAA6D;IAC7D,aAAa;IACb,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,UAAU;IACV,QAAQ;IACR,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,OAAO;AACX;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,mDAAmD;IACnD,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QACX,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA,+BAA+B;IAC/B,2BAA2B;IAC3B,IAAI;;IAEJ;QACI,sBAAsB;QACtB,eAAe;IACnB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.content {\n    display: flex;\n    grid-gap: 40px;\n    /*width: calc(100vw - 200px);*/\n    max-width: 100%;\n    width: var(--container-width);\n    padding: 28px var(--container-padding);\n    margin: auto;\n    height: calc(100vh - var(--header-height));\n\n    --group-width: 270px;\n}\n\n.groupsContainer {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n\n    /*flex-direction: row;*/\n    /*position: relative;*/\n    /*align-items: center;*/\n    grid-gap: 32px;\n}\n\n.groupsContainer > div:not(.actions) {\n    flex: 1;\n}\n\n.groups {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    column-gap: 69px;\n    row-gap: 2px;\n    margin: 0 auto;\n    /*min-width: 1086px;*/\n}\n\n.groups:not(.open) {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(var(--group-width), var(--group-width)));\n}\n\n.group {\n    position: relative;\n    width: var(--group-width);\n    /*transition: 0.1s;*/\n    /*display: flex;*/\n    /*flex-direction: column;*/\n\n    /*display: grid;*/\n    /*grid-row: span 6;*/\n    /*grid-template-rows: subgrid;*/\n}\n\n.groupTitle {\n    margin: 0 0 30px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.groupTitle button.hidden {\n    display: none;\n}\n\n.groupTitle h5 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: var(--group-width);\n    margin: auto 0;\n}\n\n.group.closed .groupTitleNumber {\n    display: none;\n}\n\n.groupTitleNumber {\n    color: var(--secondary-color);\n    font-weight: 400;\n    padding-right: 10px;\n}\n\n.groupItems {\n    flex: 1;\n    --total: 0;\n    display: flex;\n    flex-wrap: wrap;\n    transition: padding 0.1s;\n    padding-left: calc(var(--total, 0) * 8px);\n}\n\n.groupItems a > div:last-child {\n    margin-left: calc(var(--total, 0) * 8px * -1);\n}\n\n.groupItems.closed:has(a:nth-child(2):last-child) {\n    padding-top: 8px;\n    /*padding-left: 8px;*/\n    margin-top: -8px;\n}\n\n.groupItems.closed:has(a:nth-child(3):last-child) {\n    padding-top: 16px;\n    /*padding-left: 16px;*/\n    margin-top: -16px;\n}\n\n.groupItems.closed:has(a:nth-child(4)) {\n    padding-top: 24px;\n    /*padding-left: 24px;*/\n    margin-top: -24px;\n}\n\n.groupItems.closed * {\n    pointer-events: none;\n}\n\n.groupItems.open {\n    row-gap: 32px;\n    grid-template-columns: repeat(auto-fit, minmax(226px, 226px));\n    display: grid;\n    grid-gap: 60px;\n    /*justify-content: center;*/\n}\n\n.group.open {\n    width: 100%;\n}\n\n.group.hidden {\n    display: none;\n}\n\n.actions {\n    text-align: center;\n    margin: 0 0 60px auto;\n    /*padding-top: 32px;*/\n    width: 200px;\n    min-width: 200px;\n    display: flex;\n    flex-direction: column;\n    grid-gap: 16px;\n}\n\n.imgWrapper {\n    border: 1px solid #7b848e;\n    margin-bottom: 12px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    padding: 4px 24px;\n    color: #1650b4;\n    font-size: 16px;\n    width: 179px;\n    max-height: 156px;\n}\n\n.imgWrapper img {\n    margin: 0 auto;\n    max-width: 96%;\n    height: auto;\n}\n\n.selection {\n    width: 179px;\n}\n\n.selection img {\n    width: 25px;\n}\n\n.selection h6,\n.selection span {\n    font-size: 13px;\n}\n\n.selection > div {\n    margin-bottom: 4px;\n    max-width: 100%;\n}\n\n.selection > div:not(:first-child) {\n    padding-left: 32px;\n}\n\n.selection > div img {\n    width: 20px;\n}\n\n.link.open {\n    margin-right: 30px;\n}\n\n.buttons {\n    display: flex;\n    grid-gap: 16px;\n}\n\n.btnIcon {\n    display: flex;\n    align-items: center;\n    grid-gap: 11px;\n    padding-left: 13px;\n    padding-right: 21px;\n}\n\n.tableContent .tableWrapper {\n    overflow: hidden;\n    max-height: 0;\n    border-bottom: 1px solid var(--light-grey);\n}\n\n.tableWrapper td {\n    text-align: center;\n}\n\n.tableContent h3 {\n    padding: 15px 0;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.tableContent h3 button {\n    width: 25px;\n    height: 25px;\n    color: var(--dark-grey);\n    transform: rotate(90deg);\n    transition: transform 0.4s;\n}\n\n.tableContent.open .tableWrapper {\n    max-height: 100000px;\n}\n\n.tableContent.open h3 button {\n    color: var(--primary-color-active);\n    transform: rotate(180deg);\n}\n\n.tableContent table {\n    width: 100%;\n}\n\n.tableContent th {\n    position: relative;\n    padding: 9px;\n}\n.tableContent th:not(:last-child):after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    display: block;\n    width: 90%;\n    left: 5%;\n    border-bottom: 1px solid var(--dark-grey);\n}\n\n.tableContent th:first-child:after {\n    width: 95%;\n    left: 0;\n}\n\n.tableContent td {\n    padding: 4px 11px;\n}\n\n.tableContent tr:not(:last-child) td:not(:last-child) {\n    border-bottom: 1px solid var(--light-grey);\n}\n\n.selectedHeader {\n    margin-bottom: calc(var(--container-margin) - 10px);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n@media screen-md-max {\n    .content {\n        width: 100%;\n        --group-width: 240px;\n    }\n\n    .groupsContainer {\n        /*flex-direction: column;*/\n        transition: padging 0.4s;\n    }\n\n    .groups {\n        column-gap: 35px;\n    }\n\n    /*.groupsContainer.collapsed {*/\n    /*    padding-left: 300px;*/\n    /*}*/\n\n    .actions {\n        margin: auto auto 30px;\n        padding: 30px 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"content": `tax-optimisation_content__rEKve`,
	"groupsContainer": `tax-optimisation_groupsContainer__WoOdP`,
	"actions": `tax-optimisation_actions__Naaln`,
	"groups": `tax-optimisation_groups__k6Aml`,
	"open": `tax-optimisation_open__5YNxA`,
	"group": `tax-optimisation_group__4iltN`,
	"groupTitle": `tax-optimisation_groupTitle__CjnSI`,
	"hidden": `tax-optimisation_hidden__BFdT-`,
	"closed": `tax-optimisation_closed__iht76`,
	"groupTitleNumber": `tax-optimisation_groupTitleNumber__W1uYT`,
	"groupItems": `tax-optimisation_groupItems__QjZRY`,
	"imgWrapper": `tax-optimisation_imgWrapper__ccQgE`,
	"selection": `tax-optimisation_selection__xuzpm`,
	"link": `tax-optimisation_link__vXDAM`,
	"buttons": `tax-optimisation_buttons__CsTRb`,
	"btnIcon": `tax-optimisation_btnIcon__X0Ne8`,
	"tableContent": `tax-optimisation_tableContent__eU+EH`,
	"tableWrapper": `tax-optimisation_tableWrapper__SHidf`,
	"selectedHeader": `tax-optimisation_selectedHeader__8Tm9S`
};
export default ___CSS_LOADER_EXPORT___;
